// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"331b540e","191":"6f15a912","542":"a1d21565","672":"650397d3","743":"860c9702"}[chunkId] + ".chunk.css";
};